const RegisteredEvents = ({ discCode, events }) => {
    // Helper object to keep track of unique codes
    const uniqueEvents = {}; 
    const uniqueEventsFiltered = events?.filter(event => {
        if (discCode && !event?.code?.startsWith(discCode)) {
            return false; // If discCode is provided and the event code doesn't start with it, exclude the event
        }
        if (!uniqueEvents[event?.code]) {     
            uniqueEvents[event?.code] = true;     
            return true;   
        }   
        return false; 
    }); 

    return (
        <>
            {uniqueEventsFiltered
                .sort((a, b) => (a?.event?.order - b?.event?.order))
                .map(data => {
                    // Find the first event with the matching code
                    let event = events.find(ev => ev?.event?.code === data?.code)?.event;
                    return event?.description && (
                        <span key={data?.code}>
                            {event?.description}
                        </span>
                    )
                })
            }
        </>
    );
};


export default RegisteredEvents;